// /* eslint-disable */
// import React, { useEffect, useState } from 'react';
// import { shallowEqual, useDispatch, useSelector } from 'react-redux';
// import { useForm } from "react-hook-form";
// import _ from "lodash/fp";
// import QualificationNameList from './QualificationNameList';
// import masterLabels from '../labels/master_en.json';
// import commonLabels from '../../../common/labels/common_en.json';
// import { getQualificationName, addQualificationName, editQualificationName, resetQualificationName, getAllQualificationTypesCombo } from '../actions/masterManagementAction';

// const QualificationNameForm = ({ addQualificationname, rowPerPage }) => {
//     const { register, handleSubmit, errors } = useForm({
//         mode: "onChange"
//     });

//     const [viewQualificationNameList, setViewQualificationNameList] = useState(false);
//     const dispatch = useDispatch();
//     useEffect(() => {
//         dispatch(getAllQualificationTypesCombo());
//         if (addQualificationname !== '' && addQualificationname !== true) {
//             dispatch(getQualificationName(addQualificationname));
//         }
//         // eslint-disable-next-line
//     }, [])

//     const onCancelButton = () => {
//         dispatch(resetQualificationName())
//         setViewQualificationNameList(true)
//     }

//     let { qualificationTypesCombo = [], qualificationNameDetails = [] } =
//         useSelector((state) => state?.masterManagementReducer || {}, shallowEqual);

//     const onSubmit = (data, setViewQualificationNameList, addQualificationname) => {
//         let requestBody = {};
//         requestBody = {
//             "qualificationTypeCode": data.qualificationTypeCode,
//             "qualificationNameCode": data.qualificationNameCode,
//             "qualificationName": data.qualificationName,
//             "isActive": data.isActive
//         }

//         if (addQualificationname !== '' && addQualificationname !== true) {
//             requestBody.qualificationNameCode = qualificationNameDetails && qualificationNameDetails.qualificationNameDto && qualificationNameDetails.qualificationNameDto.qualificationNameCode;
//             requestBody.qualificationTypeCode = qualificationNameDetails && qualificationNameDetails.qualificationNameDto && qualificationNameDetails.qualificationNameDto.qualificationTypeCode;

//             dispatch(editQualificationName(requestBody, setViewQualificationNameList, rowPerPage));
//         } else {
//             dispatch(addQualificationName(requestBody, setViewQualificationNameList, rowPerPage));
//         }
//     }

//     return viewQualificationNameList ? (
//         <div>
//             <QualificationNameList />
//         </div>
//     ) : (
//         <form>
//             <div className="border border-light text-center w-100 p-5" >
//                 <div className='form-group'>
//                     <div className='row'>
//                         <div className='col-md-6'>
//                             <h4><p className='float-left'>{addQualificationname === true ? masterLabels.qualificationNameForm.Add_Qualification_Name : masterLabels.qualificationNameForm.Update_Qualification_Name}</p></h4>
//                         </div>
//                     </div>
//                 </div>
//                 <br />
//                 <div className='form-group'>
//                     <div className='row'>
//                         <div className='form-group col-md-3'>
//                             <label className='font-weight-bold float-left' >{masterLabels.qualificationNameForm.Qualification_Type_Code_Field_Label}<span className="redColor">*</span></label>
//                             <select
//                                 className='form-control'
//                                 name="qualificationTypeCode"
//                                 ref={register({ required: true })}
//                                 value={qualificationNameDetails && qualificationNameDetails.qualificationNameDto && qualificationNameDetails.qualificationNameDto.qualificationTypeCode}
//                                 disabled={qualificationNameDetails && qualificationNameDetails.qualificationNameDto && qualificationNameDetails.qualificationNameDto.qualificationTypeCode && true}
//                             >
//                                 <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
//                                 {qualificationTypesCombo && qualificationTypesCombo.length > 0 && qualificationTypesCombo.filter(element => element.isDeleted == false && (element.isActive === true || addQualificationname !== true)).map((element, index) =>
//                                     <option key={index} value={element.qualificationtypecode}>{element.qualificationtypename}</option>
//                                 )}
//                             </select>
//                             {_.get("qualificationTypeCode.type", errors) === "required" && (
//                                 <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
//                             )}
//                         </div>
//                         <div className='form-group col-md-3'>
//                             <label className='font-weight-bold float-left' >{masterLabels.qualificationNameForm.Qualification_Name_Code_Field_Label}<span className="redColor">*</span></label>
//                             {addQualificationname === true ?
//                                 <>
//                                     <input
//                                         type="taxt"
//                                         className="form-control"
//                                         name="qualificationNameCode"
//                                         placeholder={masterLabels.qualificationNameForm.Qualification_Name_Code_Placeholder}
//                                         defaultValue={qualificationNameDetails && qualificationNameDetails.qualificationNameDto && qualificationNameDetails.qualificationNameDto.qualificationNameCode}
//                                         ref={register({
//                                             required: true, maxLength: 50
//                                         })}
//                                     />
//                                     {_.get("qualificationNameCode.type", errors) === "required" && (
//                                         <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
//                                     )}
//                                     {_.get("qualificationNameCode.type", errors) === "maxLength" && (
//                                         <p className="errorText float-left">{commonLabels.MAX_CHAR_VALUE_50}</p>
//                                     )}
//                                 </>
//                                 :
//                                 <label className='form-control font-weight-bold float-left text-left' >{qualificationNameDetails && qualificationNameDetails.qualificationNameDto && qualificationNameDetails.qualificationNameDto.qualificationNameCode}</label>
//                             }
//                         </div>
//                         <div className='form-group col-md-4'>
//                             <label className='float-left font-weight-bold' >{masterLabels.qualificationNameForm.Qualification_Name_Field_Label}<span className="redColor">*</span></label>
//                             <input
//                                 type="text"
//                                 className="form-control"
//                                 name="qualificationName"
//                                 placeholder={masterLabels.qualificationNameForm.Qualification_Name_Placeholder}
//                                 defaultValue={qualificationNameDetails && qualificationNameDetails.qualificationNameDto && qualificationNameDetails.qualificationNameDto.qualificationName}
//                                 ref={register({
//                                     required: true, maxLength: 200
//                                 })}
//                             />
//                             {_.get("qualificationName.type", errors) === "required" && (
//                                 <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
//                             )}
//                             {_.get("qualificationName.type", errors) === "maxLength" && (
//                                 <p className="errorText float-left">{commonLabels.MAX_CHAR_VALUE_200}</p>
//                             )}
//                         </div>

//                         <div className='form-group col-md-12 d-none'>
//                             <label className='float-left font-weight-bold' >{masterLabels.qualificationNameForm.Qualification_Name_Transalation_Field_Label}<span className="redColor">*</span></label>
//                             <input
//                                 className="form-control"
//                                 rows={3}
//                                 cols={5}
//                                 name="Translations"
//                                 placeholder={masterLabels.qualificationNameForm.Qualification_Translations_Placeholder}
//                                 defaultValue={qualificationNameDetails && qualificationNameDetails.qualificationNameDto && qualificationNameDetails.qualificationNameDto.translations}
//                             />
//                             {_.get("Translations.type", errors) === "required" && (
//                                 <p className="errorText float-left">{commonLabels.MANDATORY_FIELD_MESSAGE}</p>
//                             )}
//                             {_.get("Translations.type", errors) === "maxLength" && (
//                                 <p className="errorText float-left">{commonLabels.MAX_CHAR_VALUE_500}</p>
//                             )}
//                         </div>
//                         {/* <div className='form-group col-md-2'>
//                             <label className='float-left font-weight-bold text-left w-100'>{masterLabels.qualificationNameForm.Qualification_Name_Active_Field_Label}?</label>
//                             <input
//                                 className='float-right text-right'
//                                 type="checkbox"
//                                 name="isActive"
//                                 value={true}
//                                 defaultChecked={qualificationNameDetails && qualificationNameDetails.qualificationNameDto && qualificationNameDetails.qualificationNameDto.isActive}
//                                 ref={register({})}
//                             />
//                         </div> */}
//                         <div className='form-group col-md-2 mt-4'>
//                             <div className="form-check d-flex align-items-center gap-5">
//                                 <label className='form-check-label font-weight-bold' htmlFor="isActiveCheckbox">
//                                     {masterLabels.qualificationNameForm.Qualification_Name_Active_Field_Label}?
//                                 </label>
//                                 <input
//                                     className='form-check-input'
//                                     type="checkbox"
//                                     name="isActive"
//                                     value={true}
//                                     defaultChecked={qualificationNameDetails && qualificationNameDetails.qualificationNameDto && qualificationNameDetails.qualificationNameDto.isActive}
//                                     ref={register({})}
//                                 />
//                             </div>
//                         </div>
//                     </div>
//                     <div className="row" >
//                         <div className="col-md-12 d-flex justify-content-end">
//                             <button type="button" className="btn btn-secondary " onClick={() => onCancelButton()}>
//                                 {commonLabels.BUTTONS.CANCEL}
//                             </button>
//                             <button type="submit" className=" btn btn-primary custom_button  ms-2  " onClick={handleSubmit((e) => { onSubmit(e, setViewQualificationNameList, addQualificationname) })}>
//                                 {commonLabels.BUTTONS.SAVE}
//                             </button>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </form>
//     );
// }

// export default QualificationNameForm;

/* eslint-disable */
import React, { useEffect, useState } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import _ from "lodash/fp";
import QualificationNameList from "./QualificationNameList";
import masterLabels from "../labels/master_en.json";
import commonLabels from "../../../common/labels/common_en.json";
import {
  getQualificationName,
  addQualificationName,
  editQualificationName,
  resetQualificationName,
  getAllQualificationTypesCombo,
  getQualificationNameListPagination,
} from "../actions/masterManagementAction";
import Select from "react-select";
import { toastr } from "react-redux-toastr";
import { validateFieldsForSpaces } from "../../../common/actions/commonActions";

const QualificationNameForm = ({ addQualificationname, rowPerPage }) => {
  const { register, handleSubmit, errors } = useForm({
    mode: "onChange",
  });

  const [viewQualificationNameList, setViewQualificationNameList] =
    useState(false);
  const [qualificationTypeCode, setQualificationTypeCode] = useState();

  const dispatch = useDispatch();

  const onCancelButton = () => {
    dispatch(resetQualificationName());
    setViewQualificationNameList(true);
  };

  let { qualificationTypesCombo = [], qualificationNameDetails = [] } =
    useSelector((state) => state?.masterManagementReducer || {}, shallowEqual);

  const onSubmit = (
    data,
    setViewQualificationNameList,
    addQualificationname
  ) => {
    let requestBody = {};


const isValid = validateFieldsForSpaces({
  "Qualification name": data.qualificationName,
  "Qualification name code": data.qualificationNameCode,
  "Another Field": data.someOtherField,
});

if (!isValid) return; // Stop form submission or further logic

    requestBody = {
      qualificationTypeCode: qualificationTypeCode,
      qualificationNameCode: data.qualificationNameCode,
      qualificationName: data.qualificationName,
      isActive: data.isActive,
    };

    if (addQualificationname !== "" && addQualificationname !== true) {
      requestBody.qualificationNameCode =
        qualificationNameDetails &&
        qualificationNameDetails.qualificationNameDto &&
        qualificationNameDetails.qualificationNameDto.qualificationNameCode;
      requestBody.qualificationTypeCode =
        qualificationNameDetails &&
        qualificationNameDetails.qualificationNameDto &&
        qualificationNameDetails.qualificationNameDto.qualificationTypeCode;

      dispatch(
        editQualificationName(
          requestBody,
          setViewQualificationNameList,
          rowPerPage
        )
      );
    } else {
      dispatch(
        addQualificationName(
          requestBody,
          setViewQualificationNameList,
          rowPerPage
        )
      );
    }
  };

  const onQualificatioTypeChange = (e) => {
    setQualificationTypeCode(e.target.value);
  };

  // Build options
  const qualificationOptions = qualificationTypesCombo
    ?.filter(
      (el) =>
        !el.isDeleted && (el.isActive === true || addQualificationname !== true)
    )
    .map((el) => ({
      value: el.qualificationtypecode,
      label: el.qualificationtypename,
    }));

  // Preselect value if available
  const selectedOption =
    qualificationOptions.find(
      (option) =>
        option.value === qualificationTypeCode ||
        option.value === qualificationNameDetails?.qualificationNameDto?.qualificationTypeCode
    ) || null;


  useEffect(() => {
    dispatch(getAllQualificationTypesCombo());
    if (addQualificationname !== "" && addQualificationname !== true) {
      dispatch(getQualificationName(addQualificationname));
    }
    // eslint-disable-next-line
    setQualificationTypeCode(
      qualificationNameDetails?.qualificationNameDto?.qualificationTypeCode
    );
  }, []);

  return viewQualificationNameList ? (
    <div>
      <QualificationNameList 
qualificationType={qualificationTypeCode}
      />
    </div>
  ) : (
    <form>
      <div className="border border-light text-center w-100 p-5">
        <div className="form-group">
          <div className="row">
            <div className="col-md-6">
              <h4>
                <p className="float-left">
                  {addQualificationname === true
                    ? masterLabels.qualificationNameForm.Add_Qualification_Name
                    : masterLabels.qualificationNameForm
                      .Update_Qualification_Name}
                </p>
              </h4>
            </div>
          </div>
        </div>
        <br />
        <div className="form-group">
          <div className="row">
            <div className="form-group col-md-3">
              <label className="font-weight-bold float-left">
                {
                  masterLabels.qualificationNameForm
                    .Qualification_Type_Code_Field_Label
                }
                <span className="redColor">*</span>
              </label>
              {/* <select
                                className='form-control'
                                name="qualificationTypeCode"
                                ref={register({ required: true })}
                                value={qualificationNameDetails && qualificationNameDetails.qualificationNameDto && qualificationNameDetails.qualificationNameDto.qualificationTypeCode}
                                disabled={qualificationNameDetails && qualificationNameDetails.qualificationNameDto && qualificationNameDetails.qualificationNameDto.qualificationTypeCode && true}
                            >
                                <option key={0} value="">{commonLabels.COMBO_SELECT}</option>
                                {qualificationTypesCombo && qualificationTypesCombo.length > 0 && qualificationTypesCombo.filter(element => element.isDeleted == false && (element.isActive === true || addQualificationname !== true)).map((element, index) =>
                                    <option key={index} value={element.qualificationtypecode}>{element.qualificationtypename}</option>
                                )}
                            </select> */}
              <br />

              <Select
                className="mt-1"
                name="qualificationTypeCode"
                options={qualificationOptions}
                value={selectedOption}
                onChange={(selected) => {
                  const syntheticEvent = {
                    target: {
                      name: "qualificationTypeCode",
                      value: selected?.value || "",
                    },
                  };
                  onQualificatioTypeChange &&
                    onQualificatioTypeChange(syntheticEvent);
                }}
                isDisabled={
                  !!qualificationNameDetails?.qualificationNameDto
                    ?.qualificationTypeCode
                }
                placeholder={commonLabels.COMBO_SELECT}
                isClearable
              />

              {_.get("qualificationTypeCode.type", errors) === "required" && (
                <p className="errorText float-left">
                  {commonLabels.MANDATORY_FIELD_MESSAGE}
                </p>
              )}
            </div>
            <div className="form-group col-md-3">
              <label className="font-weight-bold float-left">
                {
                  masterLabels.qualificationNameForm
                    .Qualification_Name_Code_Field_Label
                }
                <span className="redColor">*</span>
              </label>
              {addQualificationname === true ? (
                <>
                  <input
                    type="taxt"
                    className="form-control"
                    name="qualificationNameCode"
                    placeholder={
                      masterLabels.qualificationNameForm
                        .Qualification_Name_Code_Placeholder
                    }
                    defaultValue={
                      qualificationNameDetails &&
                      qualificationNameDetails.qualificationNameDto &&
                      qualificationNameDetails.qualificationNameDto
                        .qualificationNameCode
                    }
                    ref={register({
                      required: true,
                      maxLength: 50,
                    })}
                  />
                  {_.get("qualificationNameCode.type", errors) ===
                    "required" && (
                      <p className="errorText float-left">
                        {commonLabels.MANDATORY_FIELD_MESSAGE}
                      </p>
                    )}
                  {_.get("qualificationNameCode.type", errors) ===
                    "maxLength" && (
                      <p className="errorText float-left">
                        {commonLabels.MAX_CHAR_VALUE_50}
                      </p>
                    )}
                </>
              ) : (
                <label className="form-control font-weight-bold float-left text-left">
                  {qualificationNameDetails &&
                    qualificationNameDetails.qualificationNameDto &&
                    qualificationNameDetails.qualificationNameDto
                      .qualificationNameCode}
                </label>
              )}
            </div>
            <div className="form-group col-md-4">
              <label className="float-left font-weight-bold">
                {
                  masterLabels.qualificationNameForm
                    .Qualification_Name_Field_Label
                }
                <span className="redColor">*</span>
              </label>
              <input
                type="text"
                className="form-control"
                name="qualificationName"
                placeholder={
                  masterLabels.qualificationNameForm
                    .Qualification_Name_Placeholder
                }
                defaultValue={
                  qualificationNameDetails &&
                  qualificationNameDetails.qualificationNameDto &&
                  qualificationNameDetails.qualificationNameDto
                    .qualificationName
                }
                ref={register({
                  required: true,
                  maxLength: 200,
                })}
              />
              {_.get("qualificationName.type", errors) === "required" && (
                <p className="errorText float-left">
                  {commonLabels.MANDATORY_FIELD_MESSAGE}
                </p>
              )}
              {_.get("qualificationName.type", errors) === "maxLength" && (
                <p className="errorText float-left">
                  {commonLabels.MAX_CHAR_VALUE_200}
                </p>
              )}
            </div>

            <div className="form-group col-md-12 d-none">
              <label className="float-left font-weight-bold">
                {
                  masterLabels.qualificationNameForm
                    .Qualification_Name_Transalation_Field_Label
                }
                <span className="redColor">*</span>
              </label>
              <input
                className="form-control"
                rows={3}
                cols={5}
                name="Translations"
                placeholder={
                  masterLabels.qualificationNameForm
                    .Qualification_Translations_Placeholder
                }
                defaultValue={
                  qualificationNameDetails &&
                  qualificationNameDetails.qualificationNameDto &&
                  qualificationNameDetails.qualificationNameDto.translations
                }
              />
              {_.get("Translations.type", errors) === "required" && (
                <p className="errorText float-left">
                  {commonLabels.MANDATORY_FIELD_MESSAGE}
                </p>
              )}
              {_.get("Translations.type", errors) === "maxLength" && (
                <p className="errorText float-left">
                  {commonLabels.MAX_CHAR_VALUE_500}
                </p>
              )}
            </div>
            {/* <div className='form-group col-md-2'>
                            <label className='float-left font-weight-bold text-left w-100'>{masterLabels.qualificationNameForm.Qualification_Name_Active_Field_Label}?</label>
                            <input
                                className='float-right text-right'
                                type="checkbox"
                                name="isActive"
                                value={true}
                                defaultChecked={qualificationNameDetails && qualificationNameDetails.qualificationNameDto && qualificationNameDetails.qualificationNameDto.isActive}
                                ref={register({})}
                            />
                        </div> */}
            <div className="form-group col-md-2 mt-4">
              <div className="form-check d-flex align-items-center gap-5">
                <label
                  className="form-check-label font-weight-bold"
                  htmlFor="isActiveCheckbox"
                >
                  {
                    masterLabels.qualificationNameForm
                      .Qualification_Name_Active_Field_Label
                  }
                  ?
                </label>
                <input
                  className="form-check-input"
                  type="checkbox"
                  name="isActive"
                  value={true}
                  defaultChecked={
                    qualificationNameDetails &&
                    qualificationNameDetails.qualificationNameDto &&
                    qualificationNameDetails.qualificationNameDto.isActive
                  }
                  ref={register({})}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-md-12 d-flex justify-content-end">
              <button
                type="button"
                className="btn btn-secondary "
                onClick={() => onCancelButton()}
              >
                {commonLabels.BUTTONS.CANCEL}
              </button>
              <button
                type="submit"
                className=" btn btn-primary custom_button  ms-2  "
                onClick={handleSubmit((e) => {
                  onSubmit(
                    e,
                    setViewQualificationNameList,
                    addQualificationname
                  );
                })}
              >
                {commonLabels.BUTTONS.SAVE}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default QualificationNameForm;
